import { render, staticRenderFns } from "./GroupNews.vue?vue&type=template&id=741cd72a&scoped=true"
import script from "./GroupNews.vue?vue&type=script&lang=js"
export * from "./GroupNews.vue?vue&type=script&lang=js"
import style0 from "./GroupNews.vue?vue&type=style&index=0&id=741cd72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741cd72a",
  null
  
)

export default component.exports